import { TrackingContainer } from '@mc/visibility'
import { FaqWrapper } from './components/FaqWrapper'
import { trackFaq, trackFaqViewed } from './events'
import { type SectionsOptions, useFaqData } from './hooks/useFaqData'

export const FAQ = ({
  eventType,
  eventLocation,
  pageSource = '',
  className = '',
  shouldShowLargeHeader = false,
  personaFAQ = false,
  sections,
  title,
  ...props
}: {
  eventType: string
  eventLocation: string
  pageSource?: string
  className?: string
  shouldShowLargeHeader?: boolean
  personaFAQ?: boolean
  sections?: SectionsOptions
  title?: string
  id?: string
}) => {
  const { faqData } = useFaqData({
    sections,
    personaFAQ,
  })

  const trackFaqClick = ([question]: string[]) => {
    trackFaq({
      question,
      eventType,
      eventLocation,
      pageSource,
    })
  }

  return (
    <section
      {...props}
      className={`mc-py-10 ${className}`}
      data-testid='faq-section'
      id='faq'
    >
      <TrackingContainer
        config={{ threshold: 0.3 }}
        onFirstVisible={() => trackFaqViewed({ pageSource })}
      >
        <FaqWrapper
          trackFaqClick={trackFaqClick}
          faqData={faqData}
          shouldShowLargeHeader={shouldShowLargeHeader}
          mainTitle={title}
          {...props}
        />
      </TrackingContainer>
    </section>
  )
}
